export const isTextOverflowed = (element: HTMLElement | null): boolean =>
  element instanceof HTMLElement
    ? element.offsetWidth < element.scrollWidth ||
      element.clientHeight < element.scrollHeight
    : false;
